// removed by extract-text-webpack-plugin
module.exports = {"column":"c-OrderSummary__column","note":"c-OrderSummary__note","header":"c-OrderSummary__header","stepBar":"c-OrderSummary__stepBar","show":"c-OrderSummary__show","stepBarInner":"c-OrderSummary__stepBarInner"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/OrderSummary/OrderSummary.scss
// module id = 532
// module chunks = 0